/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MenuCategoryDto as DigiworkMaitreDPosDtoMenuCategoriesMenuCategoryDto } from '../../models/Digiwork/MaitreD/Pos/DTO/MenuCategories/menu-category-dto';

export interface GetMenuCategoryById$Params {
  menuCategoryId: string;
}

export function getMenuCategoryById(http: HttpClient, rootUrl: string, params: GetMenuCategoryById$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoMenuCategoriesMenuCategoryDto>> {
  const rb = new RequestBuilder(rootUrl, getMenuCategoryById.PATH, 'get');
  if (params) {
    rb.path('menuCategoryId', params.menuCategoryId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DigiworkMaitreDPosDtoMenuCategoriesMenuCategoryDto>;
    })
  );
}

getMenuCategoryById.PATH = '/api/menu-categories/{menuCategoryId}';
